/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as TYPES from './action-types';
import _ from 'lodash';
import axios from 'axios';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';

export const setBegingQtr = (payload) => {
  return {
    type: TYPES.QUARTERlY_MARKETING_BEGQTR,
    payload,
  };
};

export const setEndQtr = (payload) => {
  return {
    type: TYPES.QUARTERlY_MARKETING_ENDQTR,
    payload,
  };
};

export const setRebateCD = (payload) => {
  return {
    type: TYPES.QUARTERlY_MARKETING_REBATE_CD,
    payload,
  };
};
export const setGridData = (payload) => {
  return {
    type: TYPES.QUARTERlY_MARKETING_GRID_DATA,
    payload,
  };
};
export const setPlanTypeCD = (payload) => {
  return {
    type: TYPES.QUARTERlY_MARKETING_PLAN_TYPE,
    payload,
  };
};
export const dispatchErrorMessage = (payload) => {
  return {
    type: TYPES.SET_ERROR_MESSAGES,
    payload,
  };
};
export const dispatchMaxFrozenQtr = (payload) => {
  return {
    type: TYPES.SET_MAX_FROZEN_QTR,
    payload,
  };
};
export const getMaxQuarterForFreezeDt = () => (dispatch) => {
  return axios
    .get(`${serviceEndPoint.GET_MAXQUARTER_FOR_FREEZE_DT}`)
    .then((response) => {
      return dispatch(dispatchMaxFrozenQtr(response.data?.data));
    })
    .catch((response) => {
      dispatch(dispatchMaxFrozenQtr(response.date));
    });
};
export const resetQuarterlyMarketingStore = () => {
  return {
    type: TYPES.RESET_QUARTERLY_MARKETIING_STORE
  };
};
